import { message } from "antd"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { FiEdit2, FiTrash } from "react-icons/fi"
import styled from "styled-components"

import {
    createEmailTemplate,
    deleteEmailTemplate,
    updateEmailTemplate,
} from "../../../../../api"
import StyledFloatingButton from "../../../../_shared/components/FloatingButton"
import StyledPopconfirm from "../../../../_shared/components/Popconfirm"
import Table from "../../../../_shared/components/Table"
import ScreenTitle from "../../../../_shared/components/Typography/ScreenTitle"
import { useStateValue } from "../../../../_shared/context/AppStateStore"
import useRestTable from "../../../../_shared/hooks/usePaginatedRestResource"
import EmailTemplatesBottomSheet from "./EmailTemplatesBottomSheet"

// ----------------------------------------------------------------------------

function _EmailTemplates(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [selected, setSelected] = useState()

    const [{ token }] = useStateValue()

    const [templates, fetchTemplates, loading, pagination, total] =
        useRestTable("/email-templates", token)

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    async function handleDelete(row) {
        try {
            await deleteEmailTemplate(row.id, token)
            message.success("Template eliminato")
            fetchTemplates()
            setSelected(null)
        } catch (e) {
            // eslint-disable-next-line
            console.log(e)
            message.error("Qualcosa è andata storto")
        }
    }

    async function handleSubmit(values) {
        try {
            values?.id
                ? await updateEmailTemplate(values.id, values, token)
                : await createEmailTemplate(values, token)
            setSelected(null)
            fetchTemplates()
            message.success("Operazione eseguita con successo")
        } catch (e) {
            // eslint-disable-next-line
            console.log(e)
            message.error("Qualcosa è andato storto")
        }
    }

    function renderActions(row) {
        return (
            <div className="row-actions">
                <StyledFloatingButton onClick={() => setSelected(row)}>
                    <FiEdit2 className="icn" />
                </StyledFloatingButton>
                <StyledPopconfirm
                    placement="left"
                    title="Sei sicuro di voler eliminare questo catalogo?"
                    okText="Sì"
                    cancelText="No"
                    onConfirm={() => {
                        handleDelete(row)
                    }}
                >
                    <StyledFloatingButton>
                        <FiTrash className="icn" />
                    </StyledFloatingButton>
                </StyledPopconfirm>
            </div>
        )
    }

    function getPaginationObject() {
        return {
            size: "small",
            total: total,
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: false,
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <ScreenTitle text="Template e-mail"></ScreenTitle>
            <Table
                className="table"
                dataSource={templates}
                columns={getColumns(renderActions)}
                onChange={(pagination) => fetchTemplates({ pagination })}
                pagination={getPaginationObject()}
                loading={loading}
            />
            <EmailTemplatesBottomSheet
                onCancel={() => setSelected(null)}
                defaultValues={selected}
                open={!!selected}
                onConfirm={handleSubmit}
            />
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_EmailTemplates.propTypes = {
    className: PropTypes.string.isRequired,
}

_EmailTemplates.defaultProps = {}

// ----------------------------------------------------------------------------

const EmailTemplates = styled(_EmailTemplates)`
    & {
        h1 {
            text-align: left;
        }
        .top-bar {
            margin: 20px 0;

            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .ant-table-cell {
            .row-actions {
                display: flex;
                justify-content: space-between;
            }
        }

        .table {
            tr {
                .row-actions {
                    display: flex;
                    transition: all 0.2s ease-in-out;
                    justify-content: flex-end;
                    opacity: 0;
                    gap: 10px;
                }

                :hover {
                    .row-actions {
                        opacity: 1;
                    }
                }
            }
        }

        .icn {
            font-size: 20px;
            color: ${(props) => props?.theme?.colors?.textPrimary};
        }
    }
`
// ----------------------------------------------------------------------------

export default EmailTemplates

function getColumns(renderActions) {
    return [
        {
            key: "name",
            title: "Nome template",
            dataIndex: "name",
        },
        {
            key: "actions",
            render: renderActions,
        },
    ]
}
